export const flattenEventProves = eventProves => [
    ...(eventProves?.public || []),
    ...(eventProves?.private || []),
    ...(eventProves?.admin || []),
];

export const requestMissingProvesBatch = ({
    eventIds,
    provesByEvent,
    pendingEventIds,
    postAPI,
    onLoaded,
    onError = () => {},
}) => {
    const normalizedIds = [...new Set(eventIds.map(eventId => String(eventId)))];
    const missingIds = normalizedIds.filter(eventId => (
        provesByEvent[eventId] === undefined && !pendingEventIds.has(eventId)
    ));

    if (missingIds.length === 0) return [];

    missingIds.forEach(eventId => pendingEventIds.add(eventId));

    const clearPendingIds = () => {
        missingIds.forEach(eventId => pendingEventIds.delete(eventId));
    };

    postAPI(
        '/proves/batch',
        { events: missingIds },
        response => {
            clearPendingIds();
            const responseEvents = response?.events || {};
            const loadedProves = missingIds.reduce((result, eventId) => {
                result[eventId] = flattenEventProves(responseEvents[eventId]);
                return result;
            }, {});
            onLoaded(loadedProves);
        },
        error => {
            clearPendingIds();
            onError(error, missingIds);
        }
    );

    return missingIds;
};
